export const aboutData = {
  title: "Who I am",
  description1:
    "My name is KALASH THAKUR. I'm a full stack web developer specialised in MERN stack.",
  description2:
    "I am passionate programmer. I love to learn and explore new technologies and am Passionate about Problem Solving. I have always been curious to understand how applications work, and this curiosity brought me to the tech world.",
  image: 1,
};
